import { useEffect } from "react";

const SITE_URL = "https://novasiteworks.de";

function setMeta(selector, attrName, attrValue, content) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

/**
 * Sets title, meta description, canonical URL and Open Graph tags per page.
 * @param {string} title
 * @param {string} description
 * @param {string} [path] e.g. "/preise" — sets canonical + og:url
 */
export default function usePageMeta(title, description, path) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', "property", "og:title", title);
      setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    }
    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    }
    if (path !== undefined) {
      const url = `${SITE_URL}${path === "/" ? "/" : path}`;
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
      setMeta('meta[property="og:url"]', "property", "og:url", url);
    }
  }, [title, description, path]);
}
